import AppContext from "@/contexts/appctx/app-context";
import { initializeApollo } from "@/lib/apollo";
import { ALL_POOLS_QUERY } from "@/lib/graphql/seed-sale";
import * as Timeline from "@/seed/constants/timeline";
import { getTestPoolData } from "@/seed/shared/token/seed-round/pool-data";
import { data as tokenSaleConfig } from "@/seed/shared/token/token-sale";
import {
    getAllocationInfo,
    getDataFromContract,
    getLayoutContent,
    getSaleEventInfo,
    getTimeline,
    getVestingFromContract,
} from "@/seed/utils/sale-info";
import { checkUserFromContract, getVestingScheduleDetails } from "@/seed/utils/user-info";
import { getSeedData, getVestingData } from "@/utils/blockchain";
import { useRouter } from "next/router";
import React, { useContext, useEffect, useReducer } from "react";
import {
    initSaleAction,
    updatePurchaseProgressAction,
    updateSaleAction,
    updateTimelineAction,
} from "./pool-actions";
import PoolContext from "./pool-context";
import poolReducer from "./pool-reducer";
/**
 * NOTE smart contract:
 * - function approve cho BUSD
 * - funtion get accepted currency BUSD
 *
 * Back-end:
 * - Add whitelist link
 * - Smart contract address
 */

const PoolState = (props) => {
    const initialState = {};
    const router = useRouter();

    const appContext = useContext(AppContext);

    const { updateUser, initAlloction, updateVesting, user } = appContext;

    const [state, dispatch] = useReducer(poolReducer, initialState);

    const apolloClient = initializeApollo();

    useEffect(() => {
        if (!router.isReady) return;
        console.log("router", router);
        initPool();
        // codes using router.query
    }, [router.isReady]);

    useEffect(async () => {
        console.log("PoolState_DidUpdated", { appContext });

        const seedDataOriginal = await getSeedData(appContext?.blockchain?.seedContract);

        if (seedDataOriginal) {
            // Update data from smart contract
            updatePoolFromContract(seedDataOriginal);

            // Update checked user info
            updateUserFromContract(seedDataOriginal);
        } else {
            updatePoolNoAuth();
        }
    }, [
        // When blockchain info is ready
        appContext.blockchain,
        // When phrase are updated
        state.currentTimelineStep,
        // When whitelist has updated
        state.saleEvent?.whitelistResultLink,
    ]); // TODO: re-check

    useEffect(async () => {
        if (!appContext.user) {
            // Update checked user info
            updatePoolNoAuth();
        }

        // Update main page layout
        if (state.currentTimelineStep) {
            updateMainLayout(state.currentTimelineStep);
        }
    }, [state.currentTimelineStep]);

    useEffect(async () => {
        const hasPurchased =
            state.currentTimelineStep == Timeline.STEP_PURCHASE ||
            state.currentTimelineStep == Timeline.STEP_PURCHASE_CLOSE;

        if (state.saleContract && hasPurchased && user.isPurchased) {
            const allocation = getAllocationInfo({
                txid: "",
                saleId: state.saleEvent.saleId,
                title: state.saleEvent.title,
                tokenPrice: state.saleEvent.tokenPrice,
                salePrice: state.saleContract?.salePrice,
                estReceiveMDN: state.saleContract?.estReceiveMDN,
            });

            const vestingDataOriginal = await getVestingData(
                appContext?.blockchain?.vestingContract
            );

            const vestingDataFromContract = getVestingFromContract(vestingDataOriginal);

            console.log({ vestingDataFromContract });

            if (vestingDataFromContract) {
                const vestingSchedule = {
                    ...vestingDataFromContract,
                    details: getVestingScheduleDetails(
                        vestingDataFromContract,
                        state.saleEvent?.timeline?.claimTokenStart
                    ),
                };
                // TODO: get from back-end
                localStorage.setItem(
                    "claimTokenStart",
                    state.saleEvent?.timeline?.claimTokenStart
                );
                allocation.vestingSchedule = vestingSchedule;
            }
            console.log("initAlloction", { allocation });

            // update to
            initAlloction({ allocations: [allocation] });
        }
    }, [
        // Ready to get from contract
        state.saleContract?.salePrice,
        // When phrase are updated
        state.currentTimelineStep,
        // When user purchased
        user?.isPurchased,
    ]);

    /***
     * Init pool event at first time or count down timeup to refesh page
     */
    const initPool = async () => {
        console.log("initPool");
        const { loading, error, data } = await apolloClient.query({
            query: ALL_POOLS_QUERY,
            variables: {},
            notifyOnNetworkStatusChange: true,
        });

        console.log("initPool", { loading, error, data });
        // TODO: test -> remove bellow
        // TODO: input data test HERE

        // loading = false;
        // error = undefined;

        const commonConfig = JSON.parse(process.env.COMMON_CONFIG);
        let start, duration1, duration2, isAcceptedBusd;
        // Get from url query
        if (router?.query?.start != undefined) {
            start = router.query.start; // to second
            duration1 = router.query.duration1;
            duration2 = router.query.duration2;
            isAcceptedBusd = router.query.busd;
            console.log("start", start);
        } else {
            // OR config
            start = commonConfig.start;
            duration1 = commonConfig.duration1;
            duration2 = commonConfig.duration2;
            isAcceptedBusd = commonConfig.busd;
        }

        if (start == 0) {
            if (!state.currentTimelineStep) {
                start = (new Date().getTime() / 1000) | 0;
                localStorage.setItem("statDateTime", start);
            } else {
                start = localStorage.getItem("statDateTime");
            }
        }

        let selectedEvent;
        if (start) {
            // selectedEvent = dataTest.whitelist_1;
            selectedEvent = getTestPoolData(start, duration1, duration2, isAcceptedBusd);
            console.log("getTestPoolData", selectedEvent);
        }
        // end test
        // data.poolEvents = [selectedEvent];
        // end

        if (data?.poolEvents && data?.poolEvents.length > 0) {
            // TODO: upgrade for private sale
            const currentEventIndex = 0;
            // selectedEvent = data?.poolEvents[currentEventIndex];

            const saleEventInfo = getSaleEventInfo(selectedEvent);
            const saleTimeline = getTimeline(selectedEvent);
            const layoutContentDef = getLayoutContent(saleTimeline.currentTimelineStep);

            console.log({
                layoutContentDef,
                saleTimeline,
                currentTimelineStep: saleTimeline.currentTimelineStep,
            });

            dispatch(
                initSaleAction({
                    // TODO: remove commnent test
                    // poolEvents: data?.poolEvents,
                    // Selected event
                    currentEventIndex: currentEventIndex,
                    currentTimelineStep: saleTimeline.currentTimelineStep,
                    primaryTimeline: saleTimeline.primaryTimeline,
                    saleEvent: { ...saleEventInfo, ...saleTimeline },
                    layoutContentDef: layoutContentDef,
                })
            );

            // Update main page layout
            // updateMainLayout(saleTimeline.currentTimelineStep);
        }
    };

    /**
     * Update pool state when data from contract are fetched successfully
     */
    const updatePoolFromContract = (seedData) => {
        const dataFromContract = getDataFromContract(seedData);
        dispatch(
            updateSaleAction({
                saleContract: dataFromContract,
                saleEvent: {
                    saleProgress: {
                        soldAllocation: dataFromContract.currentBalance,
                        totalAllocation: dataFromContract.hardCap,
                    },
                },
            })
        );
    };

    /**
     * Update user when data from contract are fetched successfully
     */
    const updateUserFromContract = (seedData) => {
        const dataFromContract = checkUserFromContract(seedData);
        if (dataFromContract) {
            const { isWinner, isPurchased } = dataFromContract;
            console.log("updateUserFromContract", { seedData, isWinner, isPurchased });

            if (updateUser) updateUser({ isWinner, isPurchased });
            // TODO: check user from smart contract or BE
            updatePoolByUser({ isWinner, isPurchased });
        }
    };

    const hasWhitelistResult = (saleEvent) => {
        return saleEvent?.totalWinners && saleEvent?.whitelistResultLink;
    };

    /**
     *
     * @param {*} userInfoFromContract
     */
    const updatePoolByUser = (userInfoFromContract) => {
        console.log("updatePoolByUser");
        const { isWinner, isPurchased } = userInfoFromContract;
        let newTimelineStep;
        let layoutContentDef;
        let countdown = {};
        if (
            state.primaryTimeline == Timeline.STEP_WHITELIST &&
            state.currentTimelineStep == Timeline.STEP_WHITELIST_CLOSE &&
            hasWhitelistResult(state.saleEvent)
        ) {
            newTimelineStep = isWinner
                ? Timeline.STEP_WHITELIST_WIN
                : Timeline.STEP_WHITELIST_FAIL;
            // update countdown timer
            countdown = {
                from: NaN,
                to: state.saleEvent.timeline.purchaseStart.valueOf(),
            };
            // test
            // newTimelineStep = Timeline.STEP_WHITELIST_CLOSE;
        } else if (state.primaryTimeline == Timeline.STEP_PURCHASE) {
            console.log("updatePoolByUser", { currentTimelineStep: state.currentTimelineStep });
            if (state.currentTimelineStep !== Timeline.STEP_PURCHASE_CLOSE) {
                newTimelineStep = isPurchased
                    ? Timeline.STEP_PURCHASE_SUCCESS
                    : Timeline.STEP_PURCHASE;
            }

            // TODO: test
            // newTimelineStep = Timeline.STEP_PURCHASE;
        }

        layoutContentDef = getLayoutContent(newTimelineStep || state.currentTimelineStep); // ensure not undefined
        console.log("updatePoolByUser", { user, newTimelineStep, layoutContentDef });

        dispatch(
            updateTimelineAction({
                currentTimelineStep: newTimelineStep,
                countdown,
                tokenSaleHero: layoutContentDef.tokenSaleHero,
                // purchaseForm: layoutContentDef.purchaseForm,
            })
        );
        // updateMainLayout(newTimelineStep);
    };

    const updatePoolNoAuth = () => {
        console.log("_updatePoolNoAuth", !user?.isConnected, state.currentTimelineStep);
        if (
            state.currentTimelineStep == Timeline.STEP_WHITELIST_CLOSE &&
            !user?.isConnected &&
            hasWhitelistResult(state.saleEvent)
        ) {
            console.log(
                "_updatePoolNoAuth",
                !user?.isConnected,
                state.currentTimelineStep,
                state.saleEvent.timeline.purchaseStart
            );
            dispatch(
                updateTimelineAction({
                    countdown: {
                        from: NaN,
                        to: state.saleEvent.timeline.purchaseStart.valueOf(),
                        tba: isNaN(state.saleEvent.timeline.purchaseStart),
                    },
                    tokenSaleHero: tokenSaleConfig.whitelistCloseNoAuth.tokenSaleHero,
                })
            );
        }
    };

    /**
     * Update layout main page
     * @param {*} currentTimelineStep
     */
    const updateMainLayout = (newTimeline) => {
        // Update main page layout
        const { currentTimeline, updateTimelineStep } = props;
        if (newTimeline && updateTimelineStep && currentTimeline != newTimeline) {
            updateTimelineStep(newTimeline);
        }
    };

    // Combine state & actions
    const mapStateToContext = (state) => ({
        saleEvent: state.saleEvent,
        saleContract: state.saleContract,
        layoutContentDef: state.layoutContentDef,
    });

    const mapDispatchToContext = (dispatch) => ({
        initSale: (payload) => dispatch(initSaleAction(payload)),
        updateSale: (payload) => dispatch(updateSaleAction(payload)),
        updateTimeline: (payload) => dispatch(updateTimelineAction(payload)),
        updatePurchaseProgress: (saleProgress) =>
            dispatch(updatePurchaseProgressAction(saleProgress)),
        refreshToNext: () => initPool(),
    });

    console.log("PoolState", state);

    return (
        <PoolContext.Provider
            value={{
                ...mapStateToContext(state),
                ...mapDispatchToContext(dispatch),
            }}
        >
            {props.children}
        </PoolContext.Provider>
    );
};

export default PoolState;
